module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presence-user"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.shiftTime.username))]), _c('div', {
    staticClass: "item"
  }, [(!_vm.shiftTime.start && _vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button yellow",
    on: {
      "click": _vm.checkin
    }
  }, [_vm._v("check in")]) : _vm._e(), (_vm.shiftTime.start) ? _c('div', {
    staticClass: "time"
  }, [(!_vm.shiftTime.end && _vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.subtract('start', true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]) : _vm._e(), (!_vm.shiftTime.end && _vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.add('start', true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.shiftTime.start))]), ((!_vm.shiftTime.end && _vm.user.can_record_shift_times) || _vm.user.is_board_member) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.subtract('start')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]) : _vm._e(), ((!_vm.shiftTime.end && _vm.user.can_record_shift_times) || _vm.user.is_board_member) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.add('start')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })]) : _vm._e()]) : _vm._e()]), (_vm.shiftTime.start) ? _c('div', {
    staticClass: "item"
  }, [(!_vm.shiftTime.end && _vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button green",
    on: {
      "click": _vm.checkout
    }
  }, [_vm._v("check out")]) : _vm._e(), (_vm.shiftTime.end) ? _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v(_vm._s(_vm.shiftTime.end))]), (_vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.subtract('end')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]) : _vm._e(), (_vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.add('end')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c8050de"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PresenceEntry.vue
// module id = 1086
// module chunks = 1